export enum LicenseType {
	BY_NAMED_USERS = 'ByUsers',
	BY_HOURS = 'ByHours',
	ACTIVE_USERS = 'ActiveUsers',
	DISTRIBUTION_HOURS = 'DistributionHours',
	CONCURRENT_USERS = 'ConcurrentUsers'
}

